<template>
  <div>
    <div class="title">用户管理</div>
    <div class="container">
      <div style="display:flex;align-item:center">
        <el-input placeholder="请输入姓名/电话" v-model="input3" class="searchinput" @input="input3"></el-input>
        <el-button type="primary" class="addbtn" @click="queryuser" v-if="searchShow">查询</el-button>
        <el-button class="all" @click="reset" v-if="resetShow"> 重置</el-button>
        <!-- <el-button type="primary" class="addbtn" @click="openrole" v-if="roleshow">角色管理</el-button> -->
        <el-button type="primary" class="addbtn" @click="addUser" v-if="addnewShow">添加账号</el-button>
      </div>

      <div class="tabletype">
        <el-table :data="tableData" stripe border>
          <el-table-column prop="user.username" label="用户名"></el-table-column>
          <el-table-column prop="user.nickname" label="姓名"></el-table-column>
          <el-table-column prop="user.phone" label="联系电话"></el-table-column>
          <!-- <el-table-column prop="user.nickname" label="邮箱"></el-table-column> -->
          <el-table-column prop="dept.deptName" label="所属部门"></el-table-column>
          <el-table-column prop="role.roleName" label="角色"></el-table-column>
          <el-table-column prop="user.updateTime" label="创建时间"></el-table-column>
          <el-table-column prop="address" label="操作" align="right">
            <template slot-scope="scope">
              <div>
                <span style="margin-right:10px;cursor:pointer" @click="edit(scope.row.user.id) " v-if="editShow">
                  <img src="../../images/edit.png" />
                </span>
                <span v-if="deleteShow">
                  <img
                    src="../../images/delete.png"
                    @click="deletebtn(scope.row)"
                    style="cursor:pointer"
                  />
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="paginationmain">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalpage"
            @current-change="operatesizechange"
            :current-page.sync="pageNum"
            hide-on-single-page
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- </el-card> -->

    <el-dialog title="添加账号" :visible.sync="dialogVisible" width="900px">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加账户弹框 -->
    <add-user ref="adduser" @addsuccess="addsuccess" />
    <!-- 修改账户弹框 -->
    <edit-user ref="edituser" @editsuccess="editsuccess" />
  </div>
</template>

<script>
// import AMap from 'AMap'
import AddUser from "./addUser.vue";
import EditUser from "./editUser.vue";
import {
  getuserlist,
  deleteperson,
  changestatus,
  // addlogoperate,
  getrolelist,
  getdeptlist
} from "../../axios/api.js";
export default {
  components: { AddUser, EditUser },
  data() {
    return {
      dialogVisible: false,
      drawer: false,
      roleshow: false,
      addroleshow: false,
      deletroleshow: false,
      addusershow: false,
      editusershow: false,
      deletusershow: false,
      roleVisible: false,
      editroleshow: false,
      choiceVisible: false,
      rolename: "",
      roleData: [],
      nodekeylist: [],
      props: {
        label: "label",
        value: "id"
      },
      treedata: [],
      input3: "",
      roleoption: {},
      statuslist: {
        1: true,
        2: false
      },
      tableData: [],
      pageNum: 1,
      options: [],
      roleList: [],
      optionProps: {
        value: "adcode",
        label: "name",
        checkStrictly: true
      },
      searchShow: false,
      resetShow:false,
      addnewShow:false,
      deleteShow:false,
      editShow:false,
    };
  },

  methods: {
    btnShow(){
      const arr = localStorage.getItem('permissionList')
      let newArr=JSON.parse(arr.replace(/\n/g,"\\n").replace(/\r/g,"\\r")).filter(i=>i.type==="B");
      for (let i in newArr) {
        if (newArr[i].id == 37) {
          this.searchShow = true;
        }
        if (newArr[i].id == 39) {
          this.resetShow = true;
        }
        if (newArr[i].id == 40) {
          this.addnewShow = true;
        }
        if (newArr[i].id == 42) {
          this.editShow = true;
        }
        if (newArr[i].id == 43) {
          this.deleteShow = true;
        }
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          console.log(_);
          done();
        })
        .catch(_ => {
          console.log(_);
        });
    },

    //编辑账号
    edit(id) {
      console.log(id);
      this.$refs.edituser.openVisible(id);
    },

    //查询用户
    queryuser() {
      this.getuser();
    },

    handleChange(value) {
      console.log(value);
      if (value.length > 0) {
        this.unitId = value[2];
        this.districtId = value[1];
        this.cityId = value[0];
        this.pageNum = 1;
      } else {
        this.unitId = "";
        this.districtId = "";
        this.cityId = "";
        this.pageNum = 1;
      }
      console.log(this.districtId);
      this.getuser();
    },
    // 选择权限
    handleCheckChange(data, b) {
      console.log(data);
      console.log(b);
    },

    add() {
      this.dialogVisible = true;
    },

    // 添加账号
    addUser() {
      this.$refs.adduser.openVisible(this.roleList, this.deptList);
    },

    // 新增用户成功
    addsuccess() {
      this.getuser();
    },
    // 修改用户
    editsuccess() {
      this.getuser();
    },

    //所以单位
    reset() {
      this.pageNum = 1;
      this.districtId = "";
      this.input3 = "";
      this.cityId = "";
      this.unitId = "";
      this.value = [];
      this.getuser();
    },

    switchchange(e, b) {
      console.log(e, b);
      const params = {
        id: b,
        status: e === true ? 1 : 2
      };
      changestatus(params).then(res => {
        if (res && res.message === "success") {
          this.$message({
            message: "修改成功",
            type: "success"
          });
          this.getuser();
        }
      });
    },
    //关键字搜索
    searchtext() {
      this.pageNum = 1;
      this.getuser();
    },

    openrole() {
      this.drawer = true;
    },

    //删除用户
    deletebtn(e) {
      console.log(e);
      this.$confirm("您确定要删除该用户吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            // const params = {
            //   id: e.id
            // };
            deleteperson([e.user.id]).then(res => {
              if (res && res.code === 200) {
                this.$message({
                  message: "删除用户成功",
                  type: "success"
                });

                // const params = {
                //   userName: localStorage.getItem("username"),
                //   content: `${localStorage.getItem("username") +
                //     "删除了" +
                //     e.realName +
                //     "的账号"}`,
                //   type: 4,
                //   operateTime: this.$moment(new Date()).format(
                //     "yyyy-MM-DD HH:mm:ss"
                //   ),
                //   platform: 7,
                //   module: "用户管理"
                // };
                // addlogoperate(params).then(res => {
                //   console.log(res.data);
                //   // this.tableData = res.data.list;
                //   //
                // });
                this.getuser();
              }
            });
          }
        }
      });
    },

    //分页
    operatesizechange(e) {
      console.log(e);
      this.pageNum = e;
      this.getuser();
    },

    //获取用户列表
    getuser() {
      const params = {
        districtId: this.districtId,
        cityId: this.cityId,
        unitId: this.unitId,
        keyword: this.input3,
        pageNum: this.pageNum,
        pageSize: 10
      };
      getuserlist(params).then(res => {
        console.log(res.rows);
        // var arr = [];
        // for (var i in res.data) {
        //   if (i < this.pageNum * 10 && i >= (this.pageNum - 1) * 10) {
        //     arr.push(res.data[i]);
        //   }
        // }
        this.tableData = res.rows;
        this.totalpage = res.total;
      });
    },

    powerlist() {
      var arr = JSON.parse(localStorage.getItem("menus"));
      console.log(arr);
      for (var i in arr) {
        if (arr[i].menuId === 101) {
          this.roleshow = true;
        }
        if (arr[i].menuId === 2025) {
          this.addroleshow = true;
        }

        if (arr[i].menuId === 2026) {
          this.editroleshow = true;
        }

        if (arr[i].menuId === 2027) {
          this.deletroleshow = true;
        }

        if (arr[i].menuId === 2031) {
          this.addusershow = true;
        }

        if (arr[i].menuId === 2030) {
          this.deletusershow = true;
        }

        if (arr[i].menuId === 2029) {
          this.editusershow = true;
        }
      }
    },
    //获取角色列表
    getrolelist() {
      getrolelist([]).then(res => {
        console.log(res.rows);
        this.roleList = res.rows;
      });
    },
    //获取部门列表
    getdeptlist() {
      getdeptlist([]).then(res => {
        console.log(res.rows);
        this.deptList = res.rows;
      });
    }
  },
  created() {
    this.btnShow()
    this.getrolelist();
    this.getdeptlist();
    // 加载表格数据
    this.getuser();
    // this.powerlist();
  }
};
</script>

<style  scoped>
.container {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  text-align: left;
  border-radius: 3px;
  margin-top: 24px;
}

.title {
  text-align: left;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}

.searchbtn {
  background: #88dad5 url(../../images/big.png) no-repeat center center;
  background-size: 50%;
  border-radius: 2px;
  display: inline-block;
  width: 40px;
  height: 40px;
}

.titlebottom {
  border-bottom: 3px solid #10beb8;
  padding-bottom: 3px;
  display: inline-block;
}

.el-dialog__body {
  padding: 20px 0;
}

.addroleline {
  font-size: 16px;
  margin-bottom: 20px;
}

.addimg {
  width: 16px;
  margin-right: 10px;
}

.mr20 {
  width: 400px;
  margin-right: 10px;
  margin-left: 5px;
}

.searchinput {
  width: 300px;
  text-align: left;
  margin-right: 20px;
}

.addrole {
  text-align: center;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
}

.mainheader {
  display: flex;
  align-content: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: bold;
}

#mapContainer {
  width: 545px;
  height: 400px;
  display: inline-block;
}

.mapcontainer {
  width: 545px;
  height: 400px;
  display: inline-block;
}

.clearfix {
  display: inline-block;
}

.clearfix::after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.rightmain {
  display: flex;
  align-items: center;
}

.addbtn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.linemain {
  text-align: left;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}

.el-form-item {
  margin-bottom: 0px;
}
</style>